import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "./Button.scss";

function Button({ type = 'button', variant, label, icon, size, onClick, disabled }) {
    return (
        <button className={`button ${variant}`} type={type} onClick={onClick} disabled={disabled}>
            {icon && <FontAwesomeIcon icon={icon} size={size} className="icon"/>}
            <span className="label">{label}</span>
        </button>
    );
}

export {Button};
